import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;
/* stylelint-disable no-descending-specificity -- This rule breaks when you have multiple complex styles in one file. */

import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { palette, typography } from '../../styles';
import * as darkPalette from '../../styles/darkPalette';
import { lavender50 } from '../../styles/sharefilePalette';
import { fromThemeColors, fromThemePalette } from '../../Theme';
var backgroundColor = fromThemePalette({
  neutral: palette.blue100,
  citrixbrand: palette.teal100,
  darkcitrixbrand: darkPalette.tealHover,
  sharefilebrand: lavender50
});
var inRangeCss = function inRangeCss(props) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tbackground-color: ", ";\n\t:first-of-type > :hover {\n\t\tbackground-color: ", ";\n\t}\n"])), backgroundColor(props), palette.grey300);
};

// prettier-ignore
var startOfRangeCss = function startOfRangeCss(props) {
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tbackground: linear-gradient(to left, ", ", ", ") no-repeat 20px;\n"])), backgroundColor(props), backgroundColor(props));
};

// prettier-ignore
var endOfRangeCss = function endOfRangeCss(props) {
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tbackground: linear-gradient(to left, ", ", ", ") no-repeat -20px;\n"])), backgroundColor(props), backgroundColor(props));
};
var disabledCss = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tcursor: default;\n\t:focus > :first-of-type {\n\t\tborder: none;\n\t}\n"])));
export var StyledCell = styled.td(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\tcursor: pointer;\n\toutline: none;\n\twidth: 40px;\n\theight: 40px;\n\tmin-width: 40px;\n\tmin-height: 40px;\n\t:focus > :first-of-type {\n\t\tborder: 2px solid ", ";\n\t}\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n"])), palette.black, function (props) {
  return props.inRange && inRangeCss;
}, function (props) {
  return props.startOfRange && startOfRangeCss;
}, function (props) {
  return props.endOfRange && endOfRangeCss;
}, function (props) {
  return props.disabled && disabledCss;
});
var dateInRangeCss = css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t:hover {\n\t\tbackground-color: ", ";\n\t}\n"])), palette.grey300);
var dateDisabledCss = css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\tcolor: ", ";\n\t:hover {\n\t\tbackground-color: transparent;\n\t}\n"])), palette.grey500);
var dateNotInMonthCss = css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\tcolor: ", ";\n"])), palette.grey500);
var dateSelectedCss = function dateSelectedCss(props) {
  return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\tbackground-color: ", ";\n\tcolor: ", ";\n\t:hover {\n\t\tbackground-color: ", ";\n\t}\n"])), fromThemeColors('primary')(props), palette.white, fromThemeColors('primary')(props));
};
export var StyledDate = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tflex-direction: column;\n\tfont-size: ", ";\n\tcolor: ", ";\n\tfont-weight: ", ";\n\tborder-radius: 50%;\n\tbox-sizing: border-box;\n\t:hover {\n\t\tbackground-color: ", ";\n\t}\n\t", "\n\t", "\n\t", "\n\t", "\n"])), typography.sizes.xsml2, fromThemeColors('secondaryText'), typography.weights.semiBold, palette.grey200, function (props) {
  return props.inRange && dateInRangeCss;
}, function (props) {
  return props.disabled && dateDisabledCss;
}, function (props) {
  return !props.inCurrentMonth && dateNotInMonthCss;
}, function (props) {
  return props.isSelected && dateSelectedCss;
});
export var StyledTodayMarker = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n\tmargin-top: 4px;\n\twidth: 6px;\n\theight: 6px;\n\tborder-radius: 50%;\n\topacity: ", ";\n\tbackground-color: ", ";\n"])), function (props) {
  return props.isToday ? 1 : 0;
}, function (props) {
  return props.isSelected ? palette.white : props.isToday ? fromThemeColors('primary') : 'transparent';
});